import { useSettingsStore } from '~/stores/settings';

// Namespaced addon (e.g. "physgun.git") is granted when the tenant
// owns the bare namespace. Mirrors PanelSpecificFeatures::hasAddon.
function addonNameMatches(owned: string, wanted: string): boolean {
    if (owned === wanted) return true;
    const dot = wanted.indexOf('.');
    return dot !== -1 && owned === wanted.slice(0, dot);
}

/**
 * The addon list ships inside the settings payload, so addon state is loaded
 * exactly when settings data is. (Checking list membership here would conflate
 * "loaded" with "granted" and make a gate wait forever on a missing addon.)
 */
export function addonStateLoaded(): boolean {
    return !!useSettingsStore().data;
}

// NOTE: The initial page load will not have the required data for this due to how we prefer skeleton loading
// for page contents. Instead, using `computed` should be enough to make the feature state refresh after it is loaded.
export function hasAddon(addon: string | string[], matchAny = false): boolean {
    const settingsStore = useSettingsStore();
    const addons = settingsStore.data?.addons;

    if (!addons?.length) return false;

    const has = (name: string) => addons.some((a) => addonNameMatches(a.name, name));

    if (Array.isArray(addon)) {
        return addon[matchAny ? 'some' : 'every'](has);
    }

    return has(addon);
}
